module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.b3cbbd36.png";